import React from 'react'
import s from './style.module.css'
const AdminFooter = () => {
  return (
    <div className={s.container}>
        PizzaCo Admin
    </div>
  )
}

export default AdminFooter